import styled from 'styled-components';

export const MapControlsContainer = styled.div`
    position: fixed;
    right: 24px;
    bottom: 0;
    color: white;
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;
`;

export const Coordinate = styled.div`
    padding: 16px 0;
`;

const borderRadius = (flat?: boolean) => (flat ? 0 : '12px');
type ControlButtonProps = {
    flatTop?: boolean;
    flatBottom?: boolean;
};
export const ControlButton = styled.div<ControlButtonProps>`
    width: 40px;
    height: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(8px);
    margin: 0.5px 4px;
    border-radius: ${({flatTop, flatBottom}) =>
        [
            borderRadius(flatTop),
            borderRadius(flatTop),
            borderRadius(flatBottom),
            borderRadius(flatBottom),
        ].join(' ')};
    cursor: pointer;
`;
